import { _post, _get, _delete } from "./Axios";

export default class LaporanSummaryApi {
  static get(id = null) {
    if (id == null) {
      return _get("report/summary");
    } else {
      return _get("report/summary/" + id);
    }
  }
  static getbyparam(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("report/summary?" + params);
  }
  static post(data) {
    return _post("report/summary", data);
  }
  static update(id, data) {
    return _post("report/summary/" + id, data);
  }
  static changePassword(id, data) {
    return _post("report/summary/" + id + "/changepassword", data);
  }
  static delete(id) {
    return _delete("report/summary/" + id);
  }
  static getGroups() {
    return _get("report/summarygroups/");
  }
}
